export default __webpack_public_path__ + "static/media/i_pill_fail.146de52f.svg";